import { render } from "./ProductsDraft.vue?vue&type=template&id=6086857c&scoped=true"
import script from "./ProductsDraft.vue?vue&type=script&lang=js"
export * from "./ProductsDraft.vue?vue&type=script&lang=js"

import "./ProductsDraft.vue?vue&type=style&index=0&id=6086857c&lang=scss&scoped=true"
import "./ProductsDraft.vue?vue&type=style&index=1&id=6086857c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6086857c"]])

export default __exports__